module.exports = __webpack_public_path__ + "static/media/drop-down-icon.bea9456b.svg";